// Module
var code = `<div class="svc-carry-forward-panel-wrapper">
  <div class="svc-carry-forward-panel">
    <span data-bind="text:text"></span>
    <span class="svc-carry-forward-panel__link">
      <!-- ko component: { name: "svc-action-button", params: { text: actionText, click: onClick } }-->
      <!-- /ko -->
    </span>
  </div>
</div>`;
// Exports
export default code;